module.exports = __webpack_public_path__ + "img/time_circle.d6996f99.svg";